<template>
	<div class="alarm-records">
		<h3 class="diagnosis-title">告警记录</h3>
		<el-radio-group v-model="systemId" size="small" style="margin-top: 12px" @change="handleSystemIdChange">
			<el-radio-button label="0">GCCP</el-radio-button>
			<el-radio-button v-if="detail.bizSysType == 1" label="1">金卡云</el-radio-button>
			<el-radio-button v-if="detail.bizSysType == 2" label="2">ENESYS</el-radio-button>
		</el-radio-group>
		<div class="content" v-loading="loading">
			<gc-table :columns="columns" :table-data="tableData" :border="true" :showPage="false"></gc-table>
		</div>
	</div>
</template>

<script>
import { nameTrans } from '@/utils'
import { apiTraceAlarmList } from '@/apis/diagnosis.api'

export default {
	props: {
		detail: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			systemId: '0',
			columns: [
				{
					key: 'alarmName',
					name: '告警状态',
					render: (h, row) => {
						return h('span', {}, [
							h('i', {
								class: row.alarmStatus == 0 ? 'dot-error' : 'dot-message',
							}),
							nameTrans(row.alarmStatus, this.alarmStatus),
						])
					},
				},
				{
					key: 'createTime',
					name: '告警时间',
				},
				{
					key: 'clearTime',
					name: '告警恢复时间',
				},
			],
			tableData: [],
			loading: false,
		}
	},
	computed: {
		alarmStatus() {
			return this.$store.getters.dataList.alarmStatus || []
		},
	},
	watch: {
		detail: {
			handler({ deviceId }) {
				if (deviceId) {
					this.getAlarmList(deviceId)
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		getAlarmList(deviceId) {
			this.loading = true
			apiTraceAlarmList({ deviceId, systemId: this.systemId })
				.then(res => {
					this.tableData = res || []
				})
				.finally(() => {
					this.loading = false
				})
		},

		handleSystemIdChange() {
			this.getAlarmList(this.detail.deviceId)
		},
	},
}
</script>
<style lang="scss" scoped>
.alarm-records {
	padding-top: 20px;
	.content {
		margin-top: 16px;
		height: 380px;
	}
}
</style>
